<template>
  <DisplayGridCards :count="options.length">
    <FormFieldButtonSelect
      v-for="option in options"
      :key="option.value"
      :name="option.name"
      :value="option.value"
      :icon-url="option.iconUrl"
      :icon-do-not-force-colorization="option.iconDoNotForceColorization"
      :selected="option.selected"
      :subfield="option.subfield"
      @select="handleSelect"
    />
  </DisplayGridCards>
</template>
<script setup lang="ts">
interface Props {
  field: FormField;
}
const props = defineProps({
  field: null
});

const {
  formFieldsData: { memberValues },
} = inject(INJECT_FORM_PAGE);

const fieldValue = computed({
  get() {
    return memberValues.value[props.field.name].value;
  },
  set(value) {
    memberValues.value[props.field.name].value = value;
  },
});

const selectedIds = computed(() => {
  if (memberValues.value) {
    if (Array.isArray(fieldValue.value)) {
      return fieldValue.value;
    } else {
      return [fieldValue.value];
    }
  }

  return [];
});

const options = computed(() => {
  return props.field.options.map((option) => {
    return {
      ...option,
      selected: selectedIds.value.includes(option.value),
    };
  });
});

const { isMaxChoicesReached, openDialogMaxChoices } = useFormMaxChoices(
  props.field,
  selectedIds
);

const getSelectedIdIndex = (id) => {
  return fieldValue.value.findIndex((value) => value === id);
};

const isIdSelected = (id) => {
  const index = getSelectedIdIndex(id);
  return index > -1;
};

const selectId = (id) => {
  fieldValue.value.push(id);
};

const deselectId = (id) => {
  const index = getSelectedIdIndex(id);
  if (index > -1) fieldValue.value.splice(index, 1);
};

const toggleOption = (id) => {
  if (isIdSelected(id)) {
    deselectId(id);
  } else if (!isMaxChoicesReached.value) {
    selectId(id);
  } else {
    openDialogMaxChoices();
  }
};

const handleSelect = (id) => {
  if (props.field.multiple) {
    toggleOption(id);
  } else {
    fieldValue.value = id;
  }
};
</script>
